import { ArrowDropDown } from "@mui/icons-material";
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import { useRef } from "react";

function ButtonDropDown({ open, setOpen, handleToggle, handleClose, handleMenuItemClick, buttonOptions }) {
    const anchorRef = useRef(null);
    return (
        <>
            <ButtonGroup
                sx={{ mr: '10px' }}
                color={buttonOptions.color}
                variant="contained"
                ref={anchorRef}
            >
                <Button>{buttonOptions.title}</Button>
                <Button
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="menu"
                    onClick={() => { handleToggle(setOpen) }}
                >
                    <ArrowDropDown />
                </Button>
            </ButtonGroup>
            <Popper
                sx={{ zIndex: 1 }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={() => { handleClose(setOpen) }}>
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {buttonOptions.data.map((option, index) => (
                                        <MenuItem
                                            key={option.name}
                                            onClick={() => handleMenuItemClick(option, setOpen)}
                                        >
                                            {option.value}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default ButtonDropDown;